import { Component, OnInit } from '@angular/core';
import { TableColumn } from '@shared/interface/table.interface';
import { UtilitiesService } from '@services/utilities.service';
import { BehaviorSubject } from 'rxjs';
import { API } from '@config/constants/api.constant';
import { RolePrivilegeService } from '@services/role-privilege.service';
import { getDistributorTableColumns } from '../../../distributor.data';
import { DistributorService } from '../../../distributor.service';

@Component({
  selector: 'app-teregistrasi-active',
  styleUrls: ['./teregistrasi-active.component.scss'],
  template: `
    <app-card-table-list
      [url]="API.LIST_DISTRIBUTOR_ACTIVE"
      [tableColumns]="tableColumns"
      [privilegeDetail]="privilegeDetailActive"
      [actionPathDetail]="distributorService.BasePathDistributorDetail + '/teregistrasi/active/'"
      (totalCount)="onTotalCount($event)"
    />
  `,
})
export class TeregistrasiActiveComponent implements OnInit {
  tableColumns: TableColumn[] = getDistributorTableColumns('teregistrasi');
  privilegeDetailActive = new BehaviorSubject(false);

  public static totalCount = new BehaviorSubject(0);

  constructor(public utilities: UtilitiesService, private rolePrivilegeService: RolePrivilegeService, public distributorService: DistributorService) {}

  ngOnInit() {
    this.privilegeDetailActive.next(this.rolePrivilegeService.checkPrivilege('DISTRIBUTOR', 'LIST_TEREGISTRASI', 'TAB_LIST_ACTIVE', 'CTA_VIEW_DETAIL'));
    this.tableColumns = this.utilities.privilegeTableColumns(this.privilegeDetailActive.value, this.tableColumns);
  }

  onTotalCount = (e: number) => TeregistrasiActiveComponent.totalCount.next(e);

  protected readonly API = API;
}
